import request from "../../request.js";
import qs from "qs";

// 上次文件
export function uploadFileToYdy(data) {
  return request({
    url: "/ydy-file/uploadFileToYdy",
    method: "POST",
    data,
  });
}
// 上传文件到腾讯云-后端
export function uploadFileToTxCloudEquityFee(data) {
  return request({
    url: "/tx-cloud-file/uploadFileToTxCloudEquityFee",
    method: "POST",
    data,
  });
}
// 新增用户
export function addAjUser(data) {
  return request({
    url: "/ajUser/addAjUser",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取腾讯云秘钥
export function getPolicyTxCloudAiCourse(data) {
  return request({
    url: "tx-cloud-file/getPolicyTxCloudAiCourse",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取用户列表
export function getAjUserList(data) {
  return request({
    url: "/ajUser/getAjUserList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 编辑用户
export function updateAjUser(data) {
  return request({
    url: "/ajUser/updateAjUser",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 登录
export function doLogin(data) {
  return request({
    url: "/ajUser/doLogin",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 删除用户
export function deleteAjUser(data) {
  return request({
    url: "/ajUser/deleteAjUser",
    method: "POST",
    data: qs.stringify(data),
  });
}

// 修改用户密码-自己的
export function updateAjUserPw(data) {
  return request({
    url: "/ajUser/updateAjUserPw",
    method: "POST",
    data: qs.stringify(data),
  });
}

// 修改用户密码-管理员编辑
export function updateAjUserPwAdmin(data) {
  return request({
    url: "/ajUser/updateAjUserPwAdmin",
    method: "POST",
    data: qs.stringify(data),
  });
}

// 用户离职校验
export function updateAjUserCheckLeave(data) {
  return request({
    url: "/ajUser/updateAjUserCheckLeave",
    method: "POST",
    data: qs.stringify(data),
  });
}

//系统日志
export function getSysLogList(data) {
  return request({
    url: "/sysLog/getSysLogList",
    method: "POST",
    data,
  });
}

// ==================== 日志活跃统计 ====================
// 获取日志活跃统计列表
export function getSysLogStatisticsList(data) {
  return request({
    url: "/sysLogStatistics/getSysLogStatisticsList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取日志活跃统计详情-时间段
export function getSysLogStatisticsDetails(data) {
  return request({
    url: "/sysLogStatistics/getSysLogStatisticsDetails",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 操作日志 ====================
// 获取操作日志
export function getSysLogCopyList(data) {
  return request({
    url: "/sysLogCopy/getSysLogCopyList",
    method: "POST",
    data
  });
}
// 操作日志-复制迁移
export function updateSysLogCopyDo(data) {
  return request({
    url: "/sysLogCopy/updateSysLogCopyDo",
    method: "POST",
    data: qs.stringify(data),
  });
}

//获取权限列表
export function getAjAuthList(data) {
  return request({
    url: "/ajAuth/getAjAuthList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//新增权限列表
export function addAjAuth(data) {
  return request({
    url: "/ajAuth/addAjAuth",
    method: "POST",
    data: qs.stringify(data),
  });
}
//删除权限列表
export function deleteAjAuth(data) {
  return request({
    url: "/ajAuth/deleteAjAuth",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑权限列表
export function updateAjAuth(data) {
  return request({
    url: "/ajAuth/updateAjAuth",
    method: "POST",
    data: qs.stringify(data),
  });
}
//获取树权限列表
export function getAjAuthTree(data) {
  return request({
    url: "/ajAuth/getAjAuthTree",
    method: "POST",
    data: qs.stringify(data),
  });
}
//新建角色
export function addAjRole(data) {
  return request({
    url: "/ajRole/addAjRole",
    method: "POST",
    data: qs.stringify(data),
  });
}
//删除角色
export function deleteRole(data) {
  return request({
    url: "/ajRole/deleteRole",
    method: "POST",
    data: qs.stringify(data),
  });
}
//获取角色权限
export function getAjRoleAuthList(data) {
  return request({
    url: "/ajRole/getAjRoleAuthList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//获取角色列表
export function getAjRoleList(data) {
  return request({
    url: "/ajRole/getAjRoleList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑角色列表
export function updateAjRole(data) {
  return request({
    url: "/ajRole/updateAjRole",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑角色权限
export function updateAjRoleAuth(data) {
  return request({
    url: "/ajRole/updateAjRoleAuth",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 角色用户 ====================
// 获取角色下用户
export function getAjRoleUserList(data) {
  return request({
    url: "/ajRoleUser/getAjRoleUserList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 编辑角色下的用户
export function updateAjRoleUserMulti(data) {
  return request({
    url: "/ajRoleUser/updateAjRoleUserMulti",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 删除角色下的用户
export function deleteAjRoleUser(data) {
  return request({
    url: "/ajRoleUser/deleteAjRoleUser",
    method: "POST",
    data: qs.stringify(data),
  });
}

//新增部门
export function addDepartment(data) {
  return request({
    url: "/ajDepartment/addDepartment",
    method: "POST",
    data: qs.stringify(data),
  });
}
//获取部门
export function getDepartmentList(data) {
  return request({
    url: "/ajDepartment/getDepartmentList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑部门
export function updateDepartment(data) {
  return request({
    url: "/ajDepartment/updateDepartment",
    method: "POST",
    data: qs.stringify(data),
  });
}
//删除部门
export function deleteDepartment(data) {
  return request({
    url: "/ajDepartment/deleteDepartment",
    method: "POST",
    data: qs.stringify(data),
  });
}

//刷新权限
export function getAjUserDetailsRefresh(data) {
  return request({
    url: "/ajUser/getAjUserDetailsRefresh",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程分类-新建课程分类
export function addAjCourseClass(data) {
  return request({
    url: "/ajCourseClass/addAjCourseClass",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程分类-编辑课程分类
export function updateAjCourseClass(data) {
  return request({
    url: "/ajCourseClass/updateAjCourseClass",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程分类-获取课程分类
export function getAjCourseClassList(data) {
  return request({
    url: "/ajCourseClass/getAjCourseClassList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程分类-获取课程分类-权限
export function getAjCourseClassListOperation(data) {
  return request({
    url: "/ajCourseClass/getAjCourseClassListOperation",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程分类-删除课程分类
export function deleteAjCourseClass(data) {
  return request({
    url: "/ajCourseClass/deleteAjCourseClass",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程分类-批量导入
export function uploadAjCourseClass(data) {
  return request({
    url: "/ajCourseClass/uploadAjCourseClass",
    method: "POST",
    data,
  });
}
//课程-新增课程
export function addAjCourse(data) {
  return request({
    url: "/ajCourse/addAjCourse",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程-编辑课程
export function updateAjCourse(data) {
  return request({
    url: "/ajCourse/updateAjCourse",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程-列表课程
export function getAjCourseList(data) {
  return request({
    url: "/ajCourse/getAjCourseList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程-列表课程
export function getAjCourseListOperation(data) {
  return request({
    url: "/ajCourse/getAjCourseListOperation",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程-详情课程
export function getAjCourseDetails(data) {
  return request({
    url: "/ajCourse/getAjCourseDetails",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程-课程下架
export function updateAjCourseDown(data) {
  return request({
    url: "/ajCourse/updateAjCourseDown",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程-课程上架
export function updateAjCourseUp(data) {
  return request({
    url: "/ajCourse/updateAjCourseUp",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程-课程详情-管理
export function getAjCourseDetailsOperation(data) {
  return request({
    url: "/ajCourse/getAjCourseDetailsOperation",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程评论-获取课程评论-课程详情处（普通用户）
export function getAjCourseCommentList(data) {
  return request({
    url: "/ajCourseComment/getAjCourseCommentList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程评论-获取课程评论-管理员
export function getAjCourseCommentListOperation(data) {
  return request({
    url: "/ajCourseComment/getAjCourseCommentListOperation",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程评论-删除课程评论
export function deleteAjCourseComment(data) {
  return request({
    url: "/ajCourseComment/deleteAjCourseComment",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程评论-新增课程评论
export function addAjCourseComment(data) {
  return request({
    url: "/ajCourseComment/addAjCourseComment",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程-编辑课程讲师
export function updateAjCourseTeacher(data) {
  return request({
    url: "/ajCourse/updateAjCourseTeacher",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程-获取列表项
export function getAjCourseSearchItem(data) {
  return request({
    url: "/ajCourse/getAjCourseSearchItem",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程-删除课程大纲
export function deleteAjCourseOutline(data) {
  return request({
    url: "/ajCourseOutline/deleteAjCourseOutline",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程分类-获取三级分类
export function getAjCourseClassListChild(data) {
  return request({
    url: "/ajCourseClass/getAjCourseClassListChild",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程中心-智能搜索
export function getAjCourseListAi(data) {
  return request({
    url: "/ajCourse/getAjCourseListAi",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程-待办区查询
export function getAjCourseSelectedMine(data) {
  return request({
    url: "/ajCourseSelected/getAjCourseSelectedMine",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程-待办区新增
export function updateAjCourseSelectedAdd(data) {
  return request({
    url: "/ajCourseSelected/updateAjCourseSelectedAdd",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程-待办区删除
export function updateAjCourseSelectedRemove(data) {
  return request({
    url: "/ajCourseSelected/updateAjCourseSelectedRemove",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程-待办区清空
export function updateAjCourseSelectedClear(data) {
  return request({
    url: "/ajCourseSelected/updateAjCourseSelectedClear",
    method: "POST",
    data: qs.stringify(data),
  });
}

//课程大纲-上架
export function updateAjCourseOutlineUp(data) {
  return request({
    url: "/ajCourseOutline/updateAjCourseOutlineUp",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程大纲-批量上架
export function updateAjCourseOutlineUpMulti(data) {
  return request({
    url: "/ajCourseOutline/updateAjCourseOutlineUpMulti",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程大纲-下架
export function updateAjCourseOutlineDown(data) {
  return request({
    url: "/ajCourseOutline/updateAjCourseOutlineDown",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程大纲-批量下架
export function updateAjCourseOutlineDownMulti(data) {
  return request({
    url: "/ajCourseOutline/updateAjCourseOutlineDownMulti",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程大纲-详情
export function getAjCourseOutlineDetails(data) {
  return request({
    url: "/ajCourseOutline/getAjCourseOutlineDetails",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程大纲-查询
export function getAjCourseOutlineList(data) {
  return request({
    url: "/ajCourseOutline/getAjCourseOutlineList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程-ai优化分析大纲
export function getAjCourseOutlineRefineAi(data) {
  return request({
    url: "/ajCourse/getAjCourseOutlineRefineAi",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程-ai优化保存大纲
export function saveAjCourseOutlineRefine(data) {
  return request({
    url: "/ajCourse/saveAjCourseOutlineRefine",
    method: "POST",
    data: qs.stringify(data),
  });
}
//课程-ai优化大纲生成逻辑图
export function getAjCourseOutlineDiagramAi(data) {
  return request({
    url: "/ajCourse/getAjCourseOutlineDiagramAi",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 讲师分类 ====================
// 查询讲师分类
export function getAjTeacherClassList(data) {
  return request({
    url: "/ajTeacherClass/getAjTeacherClassList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 查询讲师分类-管理页面
export function getAjTeacherClassListOperation(data) {
  return request({
    url: "/ajTeacherClass/getAjTeacherClassListOperation",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 新增讲师分类
export function addAjTeacherClass(data) {
  return request({
    url: "/ajTeacherClass/addAjTeacherClass",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 编辑讲师分类
export function updateAjTeacherClass(data) {
  return request({
    url: "/ajTeacherClass/updateAjTeacherClass",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 删除讲师分类
export function deleteAjTeacherClass(data) {
  return request({
    url: "/ajTeacherClass/deleteAjTeacherClass",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 讲师 ====================
// 查询讲师
export function getAjTeacherList(data) {
  return request({
    url: "/ajTeacher/getAjTeacherList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 查询讲师-简单列表
export function getAjTeacherListSimple(data) {
  return request({
    url: "/ajTeacher/getAjTeacherListSimple",
    method: "POST",
    data: qs.stringify(data),
  });
}

// 查询讲师
export function getAjTeacherListOperation(data) {
  return request({
    url: "/ajTeacher/getAjTeacherListOperation",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 新增讲师
export function addAjTeacher(data) {
  return request({
    url: "/ajTeacher/addAjTeacher",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 编辑讲师
export function updateAjTeacher(data) {
  return request({
    url: "/ajTeacher/updateAjTeacher",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 删除讲师
export function deleteAjTeacher(data) {
  return request({
    url: "/ajTeacher/deleteAjTeacher",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 查询讲师详情
export function getAjTeacherDetails(data) {
  return request({
    url: "/ajTeacher/getAjTeacherDetails",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 讲师批量导入
export function uploadAjTeacher(data) {
  return request({
    url: "/ajTeacher/uploadAjTeacher",
    method: "POST",
    data,
  });
}
// 批量编辑讲师负责人
export function updateAjTeacherChargeMulti(data) {
  return request({
    url: "/ajTeacher/updateAjTeacherChargeMulti",
    method: "POST",
    data: qs.stringify(data),
  });
}
//获取讲师负责人
export function getAjUserListTeacherCharge(data) {
  return request({
    url: "/ajUser/getAjUserListTeacherCharge",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 讲师标签 ====================
// 获取讲师标签
export function getAjTeacherLabelList(data) {
  return request({
    url: "/ajTeacherLabel/getAjTeacherLabelList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 新增讲师标签
export function addAjTeacherLabel(data) {
  return request({
    url: "/ajTeacherLabel/addAjTeacherLabel",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 编辑讲师标签
export function updateAjTeacherLabel(data) {
  return request({
    url: "/ajTeacherLabel/updateAjTeacherLabel",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 删除讲师标签
export function deleteAjTeacherLabel(data) {
  return request({
    url: "/ajTeacherLabel/deleteAjTeacherLabel",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 更新课程下载数量加一
export function updateAjCourseDownloadNumAddOne(data) {
  return request({
    url: "/ajCourse/updateAjCourseDownloadNumAddOne",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 导出课程大纲
export function exportAjCourseOutline(data) {
  return request({
    url: "/ajCourseOutline/exportAjCourseOutline",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取多个课程大纲详情
export function getAjCourseOutlineDetailsByIds(data) {
  return request({
    url: "/ajCourseOutline/getAjCourseOutlineDetailsByIds",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 课程场景关联 ====================
// 删除课程场景下的课程关联
export function deleteAjCourseSpecialFour(data) {
  return request({
    url: "/ajCourseSpecialFour/deleteAjCourseSpecialFour",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 编辑课程场景下的课程关联分类
export function updateAjCourseSpecialFourClass(data) {
  return request({
    url: "/ajCourseSpecialFour/updateAjCourseSpecialFourClass",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 查询课程场景下的课程关联
export function getAjCourseSpecialFourByCourseId(data) {
  return request({
    url: "/ajCourseSpecialFour/getAjCourseSpecialFourByCourseId",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 批量查询课程场景下的课程关联
export function getAjCourseSpecialFourList(data) {
  return request({
    url: "/ajCourseSpecialFour/getAjCourseSpecialFourList",
    method: "POST",
    data: qs.stringify(data),
  });
}









































// ==================== 文件导出 ====================

// 文件魔数识别（直接比较字节）
// xlsx/docx 都是 ZIP 格式，以 PK 开头 (0x50 0x4B 0x03 0x04)
function getFileExtensionFromMagic(buffer) {
  if (!buffer || buffer.byteLength < 4) return null;

  const bytes = new Uint8Array(buffer);
  const b0 = bytes[0];
  const b1 = bytes[1];
  const b2 = bytes[2];
  const b3 = bytes[3];

  // ZIP 格式 (PK) - xlsx, docx, zip
  if (b0 === 0x50 && b1 === 0x4B && (b2 === 0x03 || b2 === 0x05 || b2 === 0x07)) {
    // 检查是否是 docx (Excel/Word 2007+)
    // docx/xlsx 的第 30-31 字节是特定的
    if (buffer.byteLength >= 32) {
      // 检查 [26:30] 是否为 "xl/" 开头 (Excel)
      const view = new Uint8Array(buffer.slice(26, 30));
      if (String.fromCharCode(...view).startsWith('xl/')) {
        return 'xlsx';
      }
      // 检查 [30:34] 是否为 "word" 开头 (Word)
      const wordView = new Uint8Array(buffer.slice(30, 34));
      if (String.fromCharCode(...wordView).startsWith('word')) {
        return 'docx';
      }
    }
    return 'xlsx'; // 默认当作 xlsx
  }

  // OLE 格式 (Excel 97-2003, Word 97-2003) - D0 CF 11 E0
  if (b0 === 0xD0 && b1 === 0xCF && b2 === 0x11 && b3 === 0xE0) {
    // 检查第 8-10 字节区分 Excel 和 Word
    if (buffer.byteLength >= 512) {
      // Excel 的工作表标识
      const view = new Uint8Array(buffer.slice(512, 520));
      const str = String.fromCharCode(...view.filter(b => b !== 0));
      if (str.includes('Workbook')) {
        return 'xls';
      }
      if (str.includes('WordDocument')) {
        return 'doc';
      }
    }
    return 'xls'; // 默认当作 xls
  }

  // PDF - 25 50 44 46 (%PDF)
  if (b0 === 0x25 && b1 === 0x50 && b2 === 0x44 && b3 === 0x46) {
    return 'pdf';
  }

  // PNG - 89 50 4E 47
  if (b0 === 0x89 && b1 === 0x50 && b2 === 0x4E && b3 === 0x47) {
    return 'png';
  }

  // JPEG - FF D8 FF
  if (b0 === 0xFF && b1 === 0xD8 && (b2 === 0xFF || b2 === 0xE0 || b2 === 0xE1 || b2 === 0xDB)) {
    return 'jpg';
  }

  // CSV - 逗号开头或 BOM
  if (b0 === 0xEF && b1 === 0xBB && b2 === 0xBF) {
    return 'csv';
  }
  if (b0 === 0x2C || b0 === 0x22) {
    return 'csv';
  }

  return null;
}

/**
 * 通用文件导出方法
 * @param {string} url - 导出接口地址
 * @param {string|Object} params - 请求参数
 * @param {string} [defaultFileName] - 默认文件名（不含扩展名）
 * @returns {Promise<void>}
 */
export async function exportFile(url, params = {}, defaultFileName = '下载文件') {
  const token = window.localStorage.getItem('zhikeTong_token');

  // 直接使用 axios，绕过拦截器
  const axios = require('axios');
  const baseURL = require('./env.js').default.baseURL;

  try {
    const response = await axios({
      method: 'POST',
      url: baseURL + url,
      data: params,
      headers: {
        'userourage': token,
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      responseType: 'arraybuffer'
    });

    // 从魔数识别文件类型
    let extension = getFileExtensionFromMagic(response.data) || 'xlsx';

    // 尝试从响应头获取文件名（Filename 字段）
    let fileName = '';
    const fileNameHeader = response.headers['filename'];
    if (fileNameHeader) {
      fileName = decodeURIComponent(fileNameHeader);
      // 如果文件名有扩展名，使用文件名的扩展名
      const nameExt = fileName.match(/\.([a-zA-Z0-9]+)$/);
      if (nameExt) {
        extension = nameExt[1].toLowerCase();
      }
    }

    // 构建最终文件名
    const finalFileName = fileName || `${defaultFileName}.${extension}`;

    // 获取 contentType（如果没有则用默认值）
    const contentType = response.headers['content-type'] || 'application/octet-stream';

    // 创建 Blob 对象
    const blob = new Blob([response.data], { type: contentType });

    // 创建下载链接
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = finalFileName;
    document.body.appendChild(link);
    link.click();

    // 清理
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    console.error('文件导出失败:', error);
    Element.Notification({
      title: '错误',
      message: '文件导出失败，请稍后重试',
      type: 'error'
    });
    throw error;
  }
}

/**
 * 导出 CSV 文件
 * @param {string} url - 导出接口地址
 * @param {Object} params - 请求参数
 * @param {string} fileName - 文件名
 */
export async function exportCsv(url, params, fileName) {
  return exportFile(url, params, fileName || '导出数据');
}

/**
 * 导出 Excel 文件
 * @param {string} url - 导出接口地址
 * @param {Object} params - 请求参数
 * @param {string} fileName - 文件名
 */
export async function exportExcel(url, params, fileName) {
  return exportFile(url, params, fileName || '导出表格');
}

/**
 * 导出 Word 文件
 * @param {string} url - 导出接口地址
 * @param {Object} params - 请求参数
 * @param {string} fileName - 文件名
 */
export async function exportWord(url, params, fileName) {
  return exportFile(url, params, fileName || '导出文档');
}

/**
 * 导出 Zip 文件
 * @param {string} url - 导出接口地址
 * @param {Object} params - 请求参数
 * @param {string} fileName - 文件名
 */
export async function exportZip(url, params, fileName) {
  return exportFile(url, params, fileName || '导出压缩包');
}

// ==================== 用户群体(适用层级) ====================
// 获取适用层级
export function getAjCourseSuitableUserList(data) {
  return request({
    url: "/ajCourseSuitableUser/getAjCourseSuitableUserList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 新增适用层级
export function addAjCourseSuitableUser(data) {
  return request({
    url: "/ajCourseSuitableUser/addAjCourseSuitableUser",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 编辑适用层级
export function updateAjCourseSuitableUser(data) {
  return request({
    url: "/ajCourseSuitableUser/updateAjCourseSuitableUser",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 删除适用层级
export function deleteAjCourseSuitableUser(data) {
  return request({
    url: "/ajCourseSuitableUser/deleteAjCourseSuitableUser",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 用户自定义代加工课程记录 ====================
// 用户自定义代加工课程-查询
export function getAjCourseSelectedCustomizeMine(data) {
  return request({
    url: "/ajCourseSelectedCustomize/getAjCourseSelectedCustomizeMine",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 代加工课程-添加
export function updateAjCourseSelectedCustomizeAdd(data) {
  return request({
    url: "/ajCourseSelectedCustomize/updateAjCourseSelectedCustomizeAdd",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 代加工课程-编辑自定义内容
export function updateAjCourseSelectedCustomizeText(data) {
  return request({
    url: "/ajCourseSelectedCustomize/updateAjCourseSelectedCustomizeText",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 代加工课程-删除
export function updateAjCourseSelectedCustomizeRemove(data) {
  return request({
    url: "/ajCourseSelectedCustomize/updateAjCourseSelectedCustomizeRemove",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 代加工课程-清空
export function updateAjCourseSelectedCustomizeClear(data) {
  return request({
    url: "/ajCourseSelectedCustomize/updateAjCourseSelectedCustomizeClear",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 代加工课程-导出Excel
export function exportAjCourseSelectedCustomize(data) {
  return request({
    url: "/ajCourseSelectedCustomize/exportAjCourseSelectedCustomize",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 讲师行程-根据讲师获取年份行程
export function getSysAjCalendarYearSchedule(data) {
  return request({
    url: "/ajTeacherSchedule/getSysAjCalendarYearSchedule",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 讲师行程-根据讲师获取年份行程
export function getAjTeacherScheduleYear(data) {
  return request({
    url: "/ajTeacherSchedule/getAjTeacherScheduleYear",
    method: "POST",
    data: qs.stringify(data),
  });
  }
// 讲师行程-讲师行程类型
export function getAjTeacherScheduleTypeList(data) {
  return request({
    url: "/ajTeacherScheduleType/getAjTeacherScheduleTypeList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 讲师行程-新增讲师日程
export function addAjTeacherSchedule(data) {
  return request({
    url: "/ajTeacherSchedule/addAjTeacherSchedule",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 讲师行程-编辑讲师日程
export function updateAjTeacherSchedule(data) {
  return request({
    url: "/ajTeacherSchedule/updateAjTeacherSchedule",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 讲师行程-讲师日程详情
export function getAjTeacherScheduleDetails(data) {
  return request({
    url: "/ajTeacherSchedule/getAjTeacherScheduleDetails",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 讲师行程-讲师日程详情
export function deleteAjTeacherSchedule(data) {
  return request({
    url: "/ajTeacherSchedule/deleteAjTeacherSchedule",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 讲师行程-编辑讲师日程表头
export function updateSysAjCalendarSchedule(data) {
  return request({
    url: "/ajTeacherSchedule/updateSysAjCalendarSchedule",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 讲师行程-讲师日程列显示权限-查询
export function getAjTeacherScheduleAuthUserMine(data) {
  return request({
    url: "/ajTeacherScheduleAuthUser/getAjTeacherScheduleAuthUserMine",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 讲师行程-讲师日程列显示权限-编辑
export function updateAjTeacherScheduleAuthUser(data) {
  return request({
    url: "/ajTeacherScheduleAuthUser/updateAjTeacherScheduleAuthUser",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 讲师行程-根据讲师获取月份日程
export function getSysAjCalendarMonthSchedule(data) {
  return request({
    url: "/ajTeacherSchedule/getSysAjCalendarMonthSchedule",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 讲师行程-根据讲师获取月份行程
export function getAjTeacherScheduleMonth(data) {
  return request({
    url: "/ajTeacherSchedule/getAjTeacherScheduleMonth",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 讲师协议 ====================
// 获取讲师协议
export function getAjTeacherAgreementList(data) {
  return request({
    url: "/ajTeacherAgreement/getAjTeacherAgreementList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 新增讲师协议
export function addAjTeacherAgreement(data) {
  return request({
    url: "/ajTeacherAgreement/addAjTeacherAgreement",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 编辑讲师协议
export function updateAjTeacherAgreement(data) {
  return request({
    url: "/ajTeacherAgreement/updateAjTeacherAgreement",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 删除讲师协议
export function deleteAjTeacherAgreement(data) {
  return request({
    url: "/ajTeacherAgreement/deleteAjTeacherAgreement",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 试讲视频 ====================
// 获取讲师视频
export function getAjTeacherCourseTrailList(data) {
  return request({
    url: "/ajTeacherCourseTrail/getAjTeacherCourseTrailList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 新增讲师视频
export function addAjTeacherCourseTrail(data) {
  return request({
    url: "/ajTeacherCourseTrail/addAjTeacherCourseTrail",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 编辑讲师视频
export function updateAjTeacherCourseTrail(data) {
  return request({
    url: "/ajTeacherCourseTrail/updateAjTeacherCourseTrail",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 删除讲师视频
export function deleteAjTeacherCourseTrail(data) {
  return request({
    url: "/ajTeacherCourseTrail/deleteAjTeacherCourseTrail",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 授课记录 ====================
// 获取讲师授课记录
export function getAjTeacherCourseHistoryList(data) {
  return request({
    url: "/ajTeacherCourseHistory/getAjTeacherCourseHistoryList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 新增讲师授课记录
export function addAjTeacherCourseHistory(data) {
  return request({
    url: "/ajTeacherCourseHistory/addAjTeacherCourseHistory",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 编辑讲师授课记录
export function updateAjTeacherCourseHistory(data) {
  return request({
    url: "/ajTeacherCourseHistory/updateAjTeacherCourseHistory",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 删除讲师授课记录
export function deleteAjTeacherCourseHistory(data) {
  return request({
    url: "/ajTeacherCourseHistory/deleteAjTeacherCourseHistory",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 课程导出失败的表格
export function exportAjCourseUploadTem(data) {
  return request({
    url: "/ajCourse/exportAjCourseUploadTem",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 系统反馈 ====================
// 获取系统反馈（所有）
export function getSysFeedbackList(data) {
  return request({
    url: "/sysFeedback/getSysFeedbackList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取系统反馈（自己的）
export function getSysFeedbackListUser(data) {
  return request({
    url: "/sysFeedback/getSysFeedbackListUser",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 新增系统反馈
export function addSysFeedback(data) {
  return request({
    url: "/sysFeedback/addSysFeedback",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 删除系统反馈
export function deleteSysFeedback(data) {
  return request({
    url: "/sysFeedback/deleteSysFeedback",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 处理系统反馈
export function updateSysFeedbackHandler(data) {
  return request({
    url: "/sysFeedback/updateSysFeedbackHandler",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 系统通知 ====================
// 获取通知列表
export function getSysNoticeList(data) {
  return request({
    url: "/sysNotice/getSysNoticeList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取未读通知数量
export function getSysNoticeUnReadNum(data) {
  return request({
    url: "/sysNotice/getSysNoticeUnReadNum",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 通知已读
export function updateSysNoticeRead(data) {
  return request({
    url: "/sysNotice/updateSysNoticeRead",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 一键已读
export function updateSysNoticeReadAll(data) {
  return request({
    url: "/sysNotice/updateSysNoticeReadAll",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 删除通知
export function deleteSysNoticeRead(data) {
  return request({
    url: "/sysNotice/deleteSysNoticeRead",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 通知标题分类
export function getSysNoticeListTitle(data) {
  return request({
    url: "/sysNotice/getSysNoticeListTitle",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 活动管理 ====================
// 查询活动列表
export function getAjActivityList(data) {
  return request({
    url: "/ajActivity/getAjActivityList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 查询活动列表-管理
export function getAjActivityListOperation(data) {
  return request({
    url: "/ajActivity/getAjActivityListOperation",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 新增活动
export function addAjActivity(data) {
  return request({
    url: "/ajActivity/addAjActivity",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 编辑活动
export function updateAjActivity(data) {
  return request({
    url: "/ajActivity/updateAjActivity",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 删除活动
export function deleteAjActivity(data) {
  return request({
    url: "/ajActivity/deleteAjActivity",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 查询活动详情
export function getAjActivityDetails(data) {
  return request({
    url: "/ajActivity/getAjActivityDetails",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 活动分类 ====================
// 获取活动分类
export function getAjActivityClassList(data) {
  return request({
    url: "/ajActivityClass/getAjActivityClassList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取所有的二级分类
export function getAjActivityClassListChild(data) {
  return request({
    url: "/ajActivityClass/getAjActivityClassListChild",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 新增活动分类
export function addAjActivityClass(data) {
  return request({
    url: "/ajActivityClass/addAjActivityClass",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 编辑活动分类
export function updateAjActivityClass(data) {
  return request({
    url: "/ajActivityClass/updateAjActivityClass",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 删除活动分类
export function deleteAjActivityClass(data) {
  return request({
    url: "/ajActivityClass/deleteAjActivityClass",
    method: "POST",
    data: qs.stringify(data),
  });
}
